import { render, staticRenderFns } from "./VtexSvg.vue?vue&type=template&id=5102d94f"
import script from "./VtexSvg.vue?vue&type=script&lang=js"
export * from "./VtexSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports